import Component from "./Button";
import Icon from "./components/Icon/ButtonIcon";
import IndicatorCounter from "./components/IndicatorCounter/ButtonIndicatorCounter";
import Label from "./components/Label/ButtonLabel";
import Loader from "./components/Loader/ButtonLoader";
import RightAddon from "./components/RightAddon/ButtonRightAddon";
import TopRightIndicator from "./components/TopRightIndicator/ButtonTopRightIndicator";
import TopRightIndicatorCounter from "./components/TopRightIndicatorCounter/ButtonTopRightIndicatorCounter";

interface IButtonExtensions {
    Icon: typeof Icon;
    IndicatorCounter: typeof IndicatorCounter;
    RightAddon: typeof RightAddon;
    Label: typeof Label;
    Loader: typeof Loader;
    TopRightIndicator: typeof TopRightIndicator;
    TopRightIndicatorCounter: typeof TopRightIndicatorCounter;
}

export const Button: typeof Component & IButtonExtensions = Object.assign(
    Component,
    {
        Icon,
        IndicatorCounter,
        RightAddon,
        Label,
        Loader,
        TopRightIndicator,
        TopRightIndicatorCounter,
    },
);

export type {
    ButtonProps,
    ButtonViews,
    ButtonSizes,
    ButtonWidth,
    ButtonStates,
} from "./types";
